import List from './List'
import * as actCustomerList from 'actions/customers/list'
import ActionBar from './ActionBar'
import ImportModal from './importModal'
import ImportModalError from './importModalError'
import ImportingModeModal from './ImportingModeModal'
import Summary from './Summary'
import {connect} from 'react-redux'
import CustomerDetail from './CustomerDetail'
import {doImportCustomer, showModalImport, showModalErrorImport} from 'actions/uploaders'
import LoadingSpinner from 'components/LoadingSpinner'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'

class ListLoyalty extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ showDetail: false })
  }

  render () {
    let { showModalImport, showModalErrorImport, messageError } = this.props.data.uploaders.import
    let { showLoadingButton } = this.props.data.buttons
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    let {summary} = this.props.data.customers.list
    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport}
          onChangeKeyword={this._onChangeKeyword}
          onChangeType={this._onChangeType}
        />
        <ContentWrapper>

          <LeftColumnWrapper openRightColumn={this.state.showDetail}>
            <Summary
              nonLoyaltyMemberTotal={summary.total_customer - summary.total_loyalty_member}
              loyaltyMemberTotal={summary.total_loyalty_member}
              rewardsTotal={summary.total_rewards_redeemed}
            />
            <div style={{top: '116px', position: 'relative'}}>
              <LoadingSpinner showLoadingSpinner={showLoadingSpinnerPage} />
            </div>
            <List showDetail={this._showDetail} closeDetail={this._closeDetail} />
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={this.state.showDetail}>
            <CustomerDetail
              onClickDone={this._closeDetail}
              showRedeemHistory={this.props.showRedeemHistory}
              showPurchaseHistory={this.props.showPurchaseHistory}
              showPointActivity={this.props.showPointActivity}
            />
          </RightColumnWrapper>
        </ContentWrapper>
        <ImportModal
          onShow={showModalImport}
          onHide={this._onClickCancelImport}
          onUpload={this._onClickUploadButton}
          showLoadingButton={showLoadingButton}
          onClickDownloadTemplate={this._onClickDownloadTemplate}
        />
        <ImportModalError
          onShow={showModalErrorImport}
          messageError={messageError}
          onClickTryBtn={this._onClickTryBtn}
          onClickCancelBtnError={this._onClickCancelBtnError}
        />
        <ImportingModeModal />
      </PageWrapper>
    )
  }

  _showDetail = () => {
    this.setState({ showDetail: true })
  }

  _closeDetail = () => {
    this.setState({ showDetail: false })
  }

  _onClickTryBtn = () => {
    this.props.dispatch(showModalImport(true))
    this.props.dispatch(showModalErrorImport(false, []))
  }

  _onClickCancelBtnError = () => {
    this.props.dispatch(showModalImport(false))
    this.props.dispatch(showModalErrorImport(false, []))
  }

  _onClickExport = () => {
    let userEmail = this.props.data.moka.user.email
    let {hasLoyalty} = this.props.data.customers.list
    let filename = 'Customer List - ' + userEmail
    this.props.dispatch(actCustomerList.customerExportRequest(filename, hasLoyalty))
  }

  _onChangeKeyword = (keyword) => {
    this.props.dispatch(actCustomerList.customersRequest({
      page: 1,
      keyword,
      type: this.props.data.customers.list.type
    }, []))
    this._closeDetail()
  }

  _onChangeType = (type) => {
    this.props.dispatch(actCustomerList.customersRequest({
      page: 1,
      keyword: this.props.data.customers.list.keyword,
      type
    }, []))
    this._closeDetail()
  }

  _onClickImport = () => {
    this.props.dispatch(showModalImport(true))
  }

  _onClickCancelImport = () => {
    this.props.dispatch(showModalImport(false))
  }

  _onClickUploadButton = (file) => {
    this.props.dispatch(doImportCustomer(file, true))
  }

  _onClickDownloadTemplate = () => {
    let userEmail = this.props.data.moka.user.email
    let filename = 'Customer List - ' + userEmail
    this.props.dispatch(actCustomerList.downloadCustomerTemplate(filename))
  }
}

function mapStateToProps (state) {
  return {
    data: state
  }
}

export default connect(mapStateToProps)(ListLoyalty)



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/ListLoyalty.js